import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Model_ResponseWorkflow, Model_VariableEnvironnementUser, AuthenticatedDTO } from 'src/app/app.models';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export abstract class AuthService {
    authenticationState$ = new BehaviorSubject(false);
    envVariables$ = new BehaviorSubject<Model_VariableEnvironnementUser[]>([]);
    pausedResponsesWorkflow$ = new BehaviorSubject<Model_ResponseWorkflow[]>([]);
    notSyncedResponsesWorkflow$ = new BehaviorSubject<Model_ResponseWorkflow[]>([]);

    set AuthSession(_session: AuthenticatedDTO | null) { localStorage.setItem(environment.LS_ABWORKFLOW_CORE_API_AUTH_SESSION, _session !== null ? JSON.stringify(_session) : 'null'); }
    get AuthSession(): AuthenticatedDTO | null {
        const lsAuthSessionStr = localStorage.getItem(environment.LS_ABWORKFLOW_CORE_API_AUTH_SESSION);
        if (lsAuthSessionStr === 'undefined' || lsAuthSessionStr === 'null') { return null; }

        let lsAuthSession: AuthenticatedDTO = null;
        try { lsAuthSession = JSON.parse(lsAuthSessionStr); } catch (e) { }
        return lsAuthSession;
    }

    constructor() {
        this.checkIfUserIsAuthenticated();
    }

    checkIfUserIsAuthenticated() {
        const authSession = this.AuthSession;
        this.authenticationState$.next(!!authSession);
    }
    
    doSignOutAction() {
        this.AuthSession = null;
        this.authenticationState$.next(false);

        return of(true);
    }

    public abstract doAuthenticateAction(_username: string, _password: string): Promise<AuthenticatedDTO>;
    public abstract doRefreshToken(): Promise<boolean>;
    public abstract doRenewExpiredPassword(_newPassword: string, _confirmPassword: string): Promise<any>;
    public abstract doRefreshStartupInfos(): Promise<void>;
    public abstract doVerifyPassword(_password: string): Promise<boolean>;
}

export class StartupInfos_Auth {
    PAUSED_RESPONSES_WORKFLOWS: Model_ResponseWorkflow[] = [];
    VARIABLES_USER: Model_VariableEnvironnementUser[] = [];
}